export default __webpack_public_path__ + "static/media/formulario_asistencia.af975aa2.svg";